
import moment from "moment";
import Vue from "vue";
import { Component } from "vue-property-decorator";

interface UserStoreDistance {
  DISTANCE: number;
  PRICE?: string;
  MIN_DELIVERY_TIME?: number;
  MAX_DELIVERY_TIME?: number;
  DELIVER_ID?: string;
}

@Component({
  props: [
    "imageSource",
    "imageSourceAlt",
    "cardId",
    "cardName",
    "click",
    "disabled",
    "cardDeliversToTable",
    "cardDeliversToBalcony",
    "cardDeliversToAddress",
    "dataDelivery",
    "cardWorkshifts",
  ],
  components: {},
})
export default class HorizontalStoreCard extends Vue {
  deliveryAt = sessionStorage.getItem("DELIVER_AT") || "";
  emptyShippingStyle = "";
  messageNotDelivered = "";
  distance = "";
  deliveryTime = "";
  deliveryPrice: string | undefined = "";

  mounted() {
    if (this.$props.dataDelivery) {
      this.formatUserStoreDistance(this.$props.dataDelivery);
    }
  }

  formatUserStoreDistance(data: UserStoreDistance): void {
    if (
      (!data.PRICE || !data.PRICE.length) &&
      this.$props.cardDeliversToAddress
    ) {
      this.emptyShippingStyle = "color: red";
      this.messageNotDelivered = "Não atende sua região para delivery";
    } else {
      this.deliveryPrice = data.PRICE;
    }

    if (data.DISTANCE) {
      if (data.DISTANCE < 1) {
        const distance = (data.DISTANCE * 1000).toFixed(0);
        this.distance = `${distance} ${distance == "1" ? "metro" : "metros"}`;
      } else {
        this.distance = `${data.DISTANCE.toFixed(2).replace(".", ",")} km`;
      }
    }

    if (data.MIN_DELIVERY_TIME && data.MAX_DELIVERY_TIME) {
      this.deliveryTime = `${data.MIN_DELIVERY_TIME}-${data.MAX_DELIVERY_TIME} min`;
    }
  }

  formatTime(stringDate: string, stringDate2: string): string {
    const momentDate = moment(stringDate);
    const momentDate2 = moment(stringDate2);
    const t1 = momentDate.lang("pt-br").format("HH:mm");
    const t2 = momentDate2.lang("pt-br").format("HH:mm");
    return t1 + "-" + t2;
  }
}
